




import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";

const LoyalityPoints = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [sortOrder, setSortOrder] = useState("desc");
  const [settings, setSettings] = useState({});


  const client_id = localStorage.getItem("client_id");

  useEffect(() => {
    fetchCustomers();
  }, []);

 const fetchCustomers = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/settings/${client_id}`
    );
    console.log("Settings API Response:", res.data);
    setSettings(res.data);

    const customerRes = await axios.get(
      `https://api.dectwinbilling.com/get-clients/${client_id}`
    );

    console.log("Customers API Response:", customerRes.data);


    setCustomers(customerRes.data || []);
  } catch (error) {
    console.log("Error fetching data:", error);
  }
};
  const sortedCustomers = [...customers].sort((a, b) => {
    if (sortOrder === "desc") {
      return (b.loyality || 0) - (a.loyality || 0);
    }
    return (a.loyality || 0) - (b.loyality || 0);
  });

  return (
    <div className="container-fluid py-4">
      <div className="card shadow border-0 rounded-4">
        <div className="card-header bg-white py-3">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
            <h4 className="mb-0 fw-bold">Loyality Points</h4>

            <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
              <h6 className="fw-bold mb-0">
                Sort by loyalty points:
              </h6>

              <div className="d-flex gap-2">
 <button
  className="btn rounded-pill"
  style={{
    backgroundColor:
      sortOrder === "desc"
        ? "var(--primary-color)"
        : "transparent",
    border: "1px solid var(--primary-color)",
    color:
      sortOrder === "desc"
        ? "#fff"
        : "var(--primary-color)",
  }}
  onClick={() => setSortOrder("desc")}
>
  High to Low
</button>
              <button
  className="btn rounded-pill"
  style={{
    backgroundColor:
      sortOrder === "asc"
        ? "var(--primary-color)"
        : "transparent",
    border: "1px solid var(--primary-color)",
    color:
      sortOrder === "asc"
        ? "#fff"
        : "var(--primary-color)",
  }}
  onClick={() => setSortOrder("asc")}
>
  Low to High
</button>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
           <thead>
  <tr>
    <th style={{ background: "var(--primary-color)", color: "#fff" }}>S.No</th>
    <th style={{ background: "var(--primary-color)", color: "#fff" }}>Customer Name</th>
    <th style={{ background: "var(--primary-color)", color: "#fff" }}>Customer Number</th>
    <th style={{ background: "var(--primary-color)", color: "#fff" }}>Loyality Points</th>
    <th style={{ background: "var(--primary-color)", color: "#fff" }}>Coequal Cash</th>
    <th style={{ background: "var(--primary-color)", color: "#fff" }}>Visits</th>
  </tr>
</thead>
              <tbody>
                {sortedCustomers.length > 0 ? (
                  sortedCustomers.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.mobile}</td>
                      <td>
                        {/* <span style={{background:"var(--primary-color"}}>
                          {item.loyality || 0}
                        </span> */}
                        <span
  style={{
    background: "var(--primary-color)",
    color: "#fff",
    padding: "4px 10px",
    borderRadius: "50px",
    fontSize: "12px",
    fontWeight: "600",
  }}
>
  {item.loyality || 0}
</span>
                      </td>
                    <td>
  ₹
  {(
    ((item.loyality || 0) *
      (settings?.set_loyal_amount || 0)) /
    100
  ).toFixed(2)}
</td>
                      <td>{item.visits || 0}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No Customers Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoyalityPoints;
